import { Injectable } from "@angular/core";


@Injectable()
export class ImageHelper {

  static resizeImage(url: string, desiredUrlSize: number, canvas: any) {
    let scaleFactor = 0.7;
    let scalingFacotor = 0.7;
    let exitGuard = 0;
    let guardExit = 5;
    const mimeType = 'image/jpeg';
    const originalSize = url.length;
    while (url.length > desiredUrlSize && exitGuard < guardExit) {
      // Logger.warn(
      //   `url length: ${url.length} > ${desiredUrlSize} -- scaleFactor: ${scaleFactor}`
      // );
      scaleFactor *= scalingFacotor;
      scalingFacotor -= 0.1;
      url = canvas.toDataURL(mimeType, scaleFactor);
      exitGuard++;
      if (originalSize == url.length) {
        exitGuard = guardExit;
      }
    }
  }

  static changeExtension(fileName: string, newExtension: string): string {
    const nameParts = fileName.split('.');
    if (nameParts.length > 1) {
      const ext = nameParts[nameParts.length - 1];
      return fileName.replace(ext, newExtension);
    } else {
      return fileName;
    }
  }

}
